<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import { authWellyMethods } from "@/state/helpers";
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    import router from '../../index'
    export default {
        components: { Layout, PageHeader },
        props: {},
        data() {
            return {
                currentStep: 1,
                name: '',
                address: '',
                lng: '',
                lat: '',
                description:'',
                file: '',
                url: '',
                glutenFree: false,
                vegan: false,
                veggie: false,
                userEmail: '',
                user:null,
                statusSend:false,
                statusMsg:""
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            onFileChange(e) {
                this.file = e.target.files[0];
                this.url = URL.createObjectURL(this.file);
            },
            goStep(val){
                this.currentStep = this.currentStep + val
            },
            async save(){
                this.statusSend = true
                let url = `${apiCore}/api/resto`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                console.log(tok)
                // eslint-disable-next-line
                console.log(this.file)

                //(1)Upload image dish
                let urlUpload = `${apiCore}/api/file/save/one`
                let formData = new FormData();
                formData.append("fileToSave", this.file);
                this.statusMsg = "Subiendo imagen..."
                let upload = await axios.post(urlUpload, formData, {
                        headers: {'Authorization': tok},
                })
                if(upload.data.valid){
                    // eslint-disable-next-line
                    console.log(upload.data)
                    //(2)Create Resto
                    let body = {
                        "nameResto":this.name,
                        "description":this.description,
                        "address":this.address,
                        "lng": this.lng,
                        "lat": this.lat,
                        "vegan": this.vegan,
                        "veggie": this.veggie,
                        "glutenFree": this.glutenFree,
                        "userEmail": this.userEmail
                    }
                    this.statusMsg = "Creando restaurante..."
                    let resto = await axios
                    .post(url, body, {
                            headers: {'Authorization': tok},
                    })

                   if(resto.data.valid){
                       // eslint-disable-next-line
                       console.log(resto.data)
                       //(3)Add image to Resto
                       let urlImageResto = `${apiCore}/api/resto/${resto.data.idRestoCreated}/addImage`
                       let bodyAdd = {
                            idFile: upload.data.idFile
                        }
                        this.statusMsg = "Asociando imagen a restaurante...."
                        let addImageToResto = await axios
                        .put(urlImageResto, bodyAdd, {
                                headers: {'Authorization': tok},
                        })
                        if(addImageToResto.data.valid){
                            // eslint-disable-next-line
                            console.log(addImageToResto.data)
                            //success create dish
                            this.statusMsg = ""
                            //this.statusSend = false
                            router.push({path:'/admin/restos'})
                        }else{
                            //no se pudo añadir la imagen
                        }
                   }else{
                       //no se pudo crear la imagen
                   }
                }else{
                    //no se pudo subir el archivo
                }
            },
            returnRestos(){
                 router.push({path:'/admin/restos'})
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div v-if='currentStep===1' class="row">
            <div class="col-md-3">
            </div>
            <div class="col-md-6">
                 <b-card 
                    :header="'¡Iniciemos!'"
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 text-center">
                                        <h3 class="title-card">
                                            Completa los datos básicos del restaurante
                                        </h3> 
                                    </div>

                                    <br/><br/><br/>

                                    <div class=" col-sm-12 col-md-5" style="margin: 10px 0 10px 0;">
                                        <img src="@/assets/images/steps/step1.svg" width="70%"/>
                                    </div>

                                    <div class=" col-sm-12 col-md-7" style="margin: 10px 0 10px 0;">
                                        <b-form-input v-model="name" type="text" placeholder="Nombre del restaurante"></b-form-input>
                                        <br/>

                                        <b-form-textarea
                                            id="description"
                                            v-model="description"
                                            placeholder="Descripción"
                                            rows="4"
                                            max-rows="4"
                                        ></b-form-textarea>
                                        <br/>

                                        <div class="file-father">
                                            <img v-if="!url" src="@/assets/images/upload.svg" width="100%"/>
                                            <img v-if="url" :src="url"  class="image-product" width="100%"/>
                                            <div class="file-child">
                                                <!--<b-form-file
                                                    v-model="file"
                                                    placeholder=""
                                                    drop-placeholder="" 
                                                    @change="onFileChange"
                                                    accept=".jpg, .png, .gif, .jpeg"
                                                >
                                                </b-form-file>-->
                                                <input type="file" class="file" model="file" @change="onFileChange" accept=".jpg, .png, .gif, .jpeg" />
                                            </div>
                                        </div>
                                        <br/><br/><br/>

                                        <div style="text-align:right;">
                                            <b-button type="submit" variant="outline-secondary" v-on:click="goStep(1)">
                                                Siguiente
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            <div class="col-md-3">
                <b-button type="submit" variant="primary" v-on:click="returnRestos()" class="btn-primary">
                    Regresar
                </b-button>
            </div>
        </div>

        <div v-if='currentStep===2' class="row">
            <div class="col-md-3">
            </div>
            <div class="col-md-6">
                 <b-card 
                    :header="'¡Falta poco!'"
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 text-center">
                                        <h3 class="title-card">
                                            Agrega información adicional del restaurante
                                        </h3> 
                                    </div>

                                    <br/><br/><br/>

                                    <div class=" col-sm-12 col-md-5" style="margin: 10px 0 10px 0;">
                                        <img src="@/assets/images/steps/step2.svg" width="70%"/>
                                    </div>

                                    <div class=" col-sm-12 col-md-7" style="margin: 10px 0 10px 0;">
                                        <b-form-input v-model="userEmail" type="text" placeholder="Email del usuario responsable"></b-form-input>
                                        <br/>

                                        <b-form-input v-model="address" type="text" placeholder="Dirección"></b-form-input>
                                        <br/>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-6">
                                                <b-form-input v-model="lat" type="number" placeholder="Latitud"></b-form-input>
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                                <b-form-input v-model="lng" type="number" placeholder="Longitud"></b-form-input>
                                            </div>
                                        </div>
                                        <br/>
                                        
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4">
                                                <b-form class="form-check form-switch form-switch-lg" @click="glutenFree=!glutenFree">
                                                    <input
                                                    class="form-check-input"
                                                    id="chkeck_cheese"
                                                    type="checkbox"
                                                    :checked="glutenFree"
                                                    />
                                                    <img src="@/assets/images/special/ACC2_BLACK.svg" style="margin: 0 5px 0 0;" height="20"/>
                                                </b-form> 
                                            </div>
                                            <div class="col-sm-12 col-md-4">
                                                <b-form class="form-check form-switch form-switch-lg" @click="veggie=!veggie">
                                                    <input
                                                    class="form-check-input"
                                                    id="chkeck_veggie"
                                                    type="checkbox"
                                                    :checked="veggie"
                                                    />
                                                    <img src="@/assets/images/special/VEGGIE_BLACK.svg" style="margin: 0 5px 0 0;" height="20"/>
                                                </b-form> 
                                            </div>
                                            <div class="col-sm-12 col-md-4">
                                                <b-form class="form-check form-switch form-switch-lg" @click="vegan=!vegan">
                                                    <input
                                                    class="form-check-input"
                                                    id="chkeck_acc"
                                                    type="checkbox"
                                                    :checked="vegan"
                                                    />
                                                    <img src="@/assets/images/special/CHEESE_BLACK.svg" style="margin: 0 5px 0 0;" height="20"/>
                                                </b-form> 
                                                
                                            </div>
                                        </div>
                                        

                                        <br/><br/><br/>

                                        <div style="text-align:right;">
                                            <b-button type="submit" variant="outline-secondary" v-on:click="goStep(-1)">
                                                Anterior
                                            </b-button>
                                            <b-button type="submit" variant="outline-secondary" v-on:click="goStep(1)">
                                                Siguiente
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            <div class="col-md-3">
                <b-button type="submit" variant="primary" v-on:click="returnRestos()" class="btn-primary">
                    Regresar
                </b-button>
            </div>
        </div>

        <div v-if='currentStep===3' class="row">
            <div class="col-md-3">
            </div>
            <div class="col-md-6">
                 <b-card 
                    :header="'¡Confirma todo!'"
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 text-center">
                                        <h3 class="title-card">
                                            El restaurante se registrará con la siguiente información
                                        </h3> 
                                    </div>

                                    <br/><br/><br/>

                                    <div class=" col-sm-12 col-md-5" style="margin: 10px 0 10px 0;">
                                        <img src="@/assets/images/steps/step3.svg" width="70%"/>
                                    </div>

                                    <div class="col-sm-12 col-md-7" style="margin: 10px 0 10px 0;">
                                        <div class="row">
                                            <div class="cols-sm-12 col-md-12 preview-product">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <img v-if="url" :src="url" class="image-product" width="66%"/>
                                                        <br/><br/>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6 foot-card" style="text-align:center;">
                                                        <div class="text-card">
                                                            <img src="@/assets/images/special/ACC2_BLACK.svg" v-show="glutenFree" style="margin: 0 5px 0 0;" height="20"/>
                                                            <img src="@/assets/images/special/VEGGIE_BLACK.svg" v-show="veggie" style="margin: 0 5px 0 0;" height="20"/>
                                                            <img src="@/assets/images/special/CHEESE_BLACK.svg" v-show="vegan" style="margin: 0 5px 0 0;" height="20"/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6" style="text-align:center;">
                                                        <span :title="'DIRECCIÓN: ' + address + ' | LAT: ' + lat + ', LNG: ' + lng">{{lat}}, {{lng}}</span>
                                                    </div>
                                                    <br/><br/>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <h3 class="title-card">
                                                            {{name}}
                                                        </h3> 
                                                        <div class="text-card">
                                                            {{description}}
                                                        </div><div class="text-card">
                                                            <b style="font-size:0.9em;">{{userEmail}}</b>
                                                        </div>
                                                        <div class="text-card" v-show="statusSend">
                                                            {{statusMsg}}
                                                        </div>
                                                        <br/>
                                                    </div>
                                                </div>
                                                <br/>
                                                <!--
                                                <div class="row">
                                                    <div class="col-md-9">
                                                    </div>
                                                    <div class="col-md-3">
                                                        <b-form class="form-check form-switch form-switch-lg" @click="() => {}">
                                                            <input
                                                            class="form-check-input"
                                                            id="input-1"
                                                            type="checkbox"
                                                            checked="checked"
                                                            />
                                                        </b-form> 
                                                    </div>
                                                </div>
                                                -->
                                            </div>

                                        </div>

                                        <br/><br/><br/>

                                        <div style="text-align:right;">
                                            <b-button type="submit" variant="outline-secondary" v-show="!statusSend" v-on:click="goStep(-1)">
                                                Anterior
                                            </b-button>
                                            <b-button type="submit" variant="outline-secondary" v-show="!statusSend" v-on:click="save()">
                                                Confirmar
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            <div class="col-md-3">
                <b-button type="submit" variant="primary" v-on:click="returnRestos()" class="btn-primary">
                    Regresar
                </b-button>
            </div>
        </div>
        <br/><br/><br/>

    </Layout>
</template>

<style scoped>

</style>